import { render, staticRenderFns } from "./article-alternatives.vue?vue&type=template&id=27e96af2"
import script from "./article-alternatives.vue?vue&type=script&lang=js"
export * from "./article-alternatives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports